import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { NotifyNewContentComponent } from "src/app/components/ui/notify-new-content/notify-new-content.component";
import { DirectivesModule } from "src/app/modules/bootstrap/directives/directives.module";

@NgModule({
  imports: [CommonModule, TranslocoModule, DirectivesModule],
  declarations: [NotifyNewContentComponent],
  exports: [NotifyNewContentComponent]
})
export class NotifyNewContentModule {}
